import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiService, Request } from "../../api";
import { useParams } from "react-router-dom";
import { Card, Row, Col, Tag, Tabs } from "antd";
import { ViewApprovers } from "../../components";

import RenderViewComponent from "../../components/RenderViewComponent";
import ActionsDropdown from "../../components/ActionsDropdown";
import CommentComponent from "../../components/CommentComponent";
import { useTabTitle } from "../../tabs/tabContext";

const ViewRequestPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState<Request | undefined>(undefined);
  const [fetch, setFetch] = useState<number>(0);

  // Show the request number as this tab's title once it's loaded.
  useTabTitle(data?.number);

  const loadRequest = async () => {
    const response = await ApiService.apiMainRequestsRetrieve(parseInt(id!));
    setData(response);
  };

  useEffect(() => {
    loadRequest();
  }, [id, fetch]);

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>
          <h2>
            {t("View")}: {data?.number} |{" "}
            <Tag>{data && data.status && data.status.name}</Tag>
          </h2>
        </Col>
        <Col>
          <ActionsDropdown
            id={id}
            number={data?.number}
            status={data?.status}
            fetch={fetch}
            setFetch={setFetch}
          />
        </Col>
      </Row>
      {data &&
        data.template.form_templates.map((ft) => (
          <Card title={t(ft.title)}>
            <RenderViewComponent
              form={ft}
              requestId={parseInt(id!)}
              readonly={true}
              onSuccess={() => {}}
            />
          </Card>
        ))}
      {data &&
        data.template.workflows.map((w) => (
          <Card title={w.name}>
            <ViewApprovers
              requestId={id}
              workflowId={w.id}
              fetch={fetch}
              setFetch={setFetch}
            />
          </Card>
        ))}
    </div>
  );
};

export default ViewRequestPage;
